<div class="ppl-mt20 p-2">
  @if(staffView) {
  <div class="custom-row pr-3">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="onCancel()"></ppl-button>
  </div>
  }
  <div class="warning-message mb-4 alert alert-warning pt-1 pb-3">
    <span class="fs-6"><strong>Warning: </strong>Manually entering time or editing a clock in /clock out time is not EVV
      compliant. Please
      remember to use the Time4Care app to clock in /clock out in real-time.</span>
  </div>

  <form nz-form nz-row [formGroup]="addTimesheetForm" class="ppl-p0 mt-2">
    @if(entryPage === 'timesheets') {
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="lastName" class="ppl-form-label">Provider PPL ID<span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <input nz-input formControlName="providerPplId" id="providerPplId" />
        </nz-form-control>
        <div class="mr-2 mb-4 ml-2">
          <ppl-button label="Get Consumers" (click)="getConsumersAndPayPeriod()" [customClass]="'primary-button'"
            [iconPosition]="'left'"></ppl-button>
        </div>
      </nz-row>
      @if (pplIdError) {
      <span class="pl-1 error-message">Please enter a PPL ID to search.</span>
      }

    </nz-form-item>

    }

    @if(showFormFields) {

    @if(entryType === 'timeEntry' || action === 'edit'){
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumer" class="ppl-form-label">
          Consumer
          <span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <nz-select formControlName="consumer" class="ppl-select" nzId="consumer" nzPlaceHolder="Select Consumer"
            nzShowSearch (ngModelChange)="enableTimesheetForm($event)">
            @for(opt of consumers; track $index){
            <nz-option [nzLabel]="opt.consumerFullName" [nzValue]="opt.consumerId"></nz-option>
            }
          </nz-select>

          @if(!consumers || consumers.length == 0){
          <span class="pl-1 error-message">You don't have any active consumers.</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" class="ppl-form-label">
          Service Period
          <span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <nz-select class="ppl-select" id="period" formControlName="period" nzPlaceHolder="Service Period" nzShowSearch
            (ngModelChange)="enableTimesheetForm($event)">
            @for(opt of payPeriod; track $index){
            <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(showEntries){
    <!-- @if(entryType === 'timeEntry'){ -->
    <table class="table">
      <thead>
        <tr>
          <th style="background-color: #a8e4e14d; width: 3%;"></th>
          <th style="background-color: #a8e4e14d; width: 15%;">Date</th>
          <th style="background-color: #a8e4e14d; width: 20%;">Service Description</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Time In</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Time Out</th>
          <th style="background-color: #a8e4e14d; width: 10%;">Units (15 Mins increment)</th>
          @if(entryType === 'timeEntry' || action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 20%;">Manual Reason*</th>
          @if(action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 8%;">Status</th>
          }
          @if(action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 17%;">Processing Status</th>
          }
          @if(entryType === 'timeEntry' || action === 'edit'){
          <th style="background-color: #a8e4e14d; width: 10%;">Actions</th>
          }
          }
        </tr>
      </thead>
      <tbody formArrayName="timesheetEntries">
        <tr *ngFor="let entry of timesheetEntries.controls; let i = index" [formGroupName]="i">
          <td style="padding-left: 15px;">
            <label nz-checkbox formControlName="selected">
            </label>
          </td>
          <td>
            <span>{{ entry.get('serviceDate')?.value | dateWithDayOfWeek }}</span>
          </td>
          <!-- <ng-container formArrayName="timeSlots">
            <ng-container *ngFor="let timeSlot of getTimeSlots(i).controls; let j = index" [formGroupName]="j"> -->
          @if(entryType === 'timeEntry' || action==='edit'){
          <td>
            @if(entryType === 'timeEntry') {
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
              nzAllowClear (ngModelChange)="checkService($event, i)"
              [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <nz-option *ngFor="let opt of getFilteredServiceCodesForDate(entry.get('serviceDate')?.value)"
                [nzLabel]="opt.serviceModifierDescription" [nzValue]="opt"></nz-option>
            </nz-select>
            } @else {
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
              nzAllowClear (ngModelChange)="checkService($event, i)"
              [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <nz-option *ngFor="let opt of serviceCodes" [nzLabel]="opt.serviceModifierDescription"
                [nzValue]="opt"></nz-option>
            </nz-select>
            }
            @if(rowStatus[i] && (entryType === 'timeEntry' || action === 'edit')){
            <div style="margin: 4px 0;">
              <nz-select class="ppl-select" formControlName="additionalConsumerId" nzPlaceHolder="Select Consumer"
                nzShowSearch nzAllowClear [ngClass]="{ 'error-border': isFieldEmpty('additionalConsumerId', i)}">
                <nz-option *ngFor="let opt of additionalConsumers" [nzLabel]="opt.consumerFullName"
                  [nzValue]="opt"></nz-option>
              </nz-select>
            </div>
            }
          </td>
          }
          @else {
          <td>
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
              nzAllowClear (ngModelChange)="checkService($event, i)"
              [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
              <nz-option *ngFor="let opt of serviceCodesTO" [nzLabel]="opt.description" [nzValue]="opt"></nz-option>
            </nz-select>
          </td>
          }
          <td>
            <p-calendar formControlName="serviceTimeIn" [timeOnly]="true"  [hourFormat]="'12'" 
              placeholder="HH:MM AM/PM"
              [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn', i) || isBilledUnitsNegative(i) }">
            </p-calendar>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOut']">
              <p class="error-message">Service Time In cannot be equal to Service Time Out.</p>
            </div>
          </td>
          <td>
            <p-calendar formControlName="serviceTimeOut" [timeOnly]="true"  [hourFormat]="'12'" 
            placeholder="HH:MM AM/PM"
            [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut', i) || isBilledUnitsNegative(i) }">
          </p-calendar>
          </td>
          <td>
            <input nz-input formControlName="billedUnits" id="billedUnits" />
          </td>
          @if(entryType === 'timeEntry' || action === 'edit'){
          <td>
            <nz-select class="ppl-select" formControlName="manualReasonLkp" nzPlaceHolder="Select Reason" nzShowSearch
              nzAllowClear [ngClass]="{ 'error-border': isFieldEmpty('manualReasonLkp', i) }">
              @for(opt of reasonList; track $index){
              <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
              }
            </nz-select>
          </td>
          @if(action === 'edit'){
          <td>
            <p>{{ timesheetEntries.get([i, 'businessStatusLkp'])?.value || null }}</p>
          </td>
          }
          @if(action === 'edit'){
          <td>
            @if(timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i,
            'applicationStatusLkp'])?.value == 'Denied') {
            <p class="hyperlink" (click)="rowClickedTs(timesheetEntries.get([i,
              'applicationStatusLkp'])?.value || null, timesheetEntries.get([i,
              'timeSheetDetailId'])?.value || null)">{{ timesheetEntries.get([i,
              'applicationStatusLkp'])?.value || null }}</p>
            } @else {
            <p>{{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || null }}</p>
            }
          </td>
          }
          @if(action === 'edit'){
          <td>
            <div class="custom-btn-row">
              @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value !== 'Paid' || timesheetEntries.get([i,
              'businessStatusLkp'])?.value !== 'Good to Pay') {
              <div nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container mr-2">
                <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
                <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container mr-2">
                <ppl-button label="" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
              }

              @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value === 'Saved'){
              <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
                <ppl-button label="" (click)="openConfirmationPopup(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
              }
            </div>
          </td>
          }

          @if(entryType === 'timeEntry' && action !== 'edit') {
          <td>
            <div class="custom-btn-row">
              <div nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container mr-2">
                <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
                <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                  (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                  [iconPosition]="'left'"></ppl-button>
              </div>
              <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container mr-2">
                <ppl-button label="" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                  [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
              </div>
            </div>
          </td>
          }

          <!-- </ng-container>
          </ng-container> -->

          }
        </tr>
      </tbody>
      <!-- </table>
    }
    @else {
    <table class="table">
      <thead>
        <tr>
          <th style="padding-left:24px; background-color: #a8e4e14d; width: 25%;">Date</th>
          <th style="background-color: #a8e4e14d; width: 25%;">Service Code</th>
          <th style="background-color: #a8e4e14d; width: 25%;">Hours</th>
          <th style="background-color: #a8e4e14d; width: 25%;">Units</th>
        </tr>
      </thead>
      <tbody formArrayName="timeoffEntries">
        <tr *ngFor="let entry of timeoffEntries.controls; let i = index" [formGroupName]="i">
          <td style="padding-left:24px;">
            <span>{{ entry.get('serviceDate')?.value }}</span>
          </td>

          <td>
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
              nzAllowClear>
              <nz-option *ngFor="let opt of timeOffServiceCodes" [nzLabel]="opt.code" [nzValue]="opt"></nz-option>
            </nz-select>
          </td>
          <td>
            <input nz-input formControlName="hrs" id="hrs" />
          </td>
          <td>
            <input nz-input formControlName="billedUnits" id="billedUnits" />
          </td>
        </tr>
      </tbody>
    } -->
    </table>

    <div class="custom-row">
      <label nz-checkbox formControlName="isAgreed" [ngClass]="{'error-class': isConsentRequired && !isAgreed}">
        By signing below, I certify that I have provided the services to the consumer during the times described on this
        timesheet.
      </label>
    </div>
    @if(entryType === 'timeEntry' || action === 'edit'){
    <div class="custom-row" style="width: 100%;">
      @if( !isExternal && entryPage !== 'timesheets') {
      <ppl-button [disabled]="isSaveDisabled" (click)="onMoveBack()" style="margin-right: 8px;" label="Move Back"
        icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      @if(entryPage !== 'timesheets') {
      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('save')" style="margin-right: 8px;"
        label="Save" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('submit')"
        [label]="entryPage === 'timesheets' ? 'Submit' : 'Save & Submit'" icon="fa fa-check-circle"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }
    @else{
    <!-- *authorize="[pageId, tabId, 'saveTimeOff', 'button']"  -->
    <div class="custom-row" style="width: 100%;">
      <ppl-button (click)="saveTimeOff()" style="margin-right: 8px;" label="Submit" icon="fa fa-check-circle"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }

    }
    @else {
    @if (addTimesheetForm.get('consumer')?.value && addTimesheetForm.get('period')?.value) {
    <p>No Authorization for pay period and consumer.</p>
    }
    @if (showFormFields && entryType !== 'timeOff' && consumers?.length < 1 ) { <p>You don't have any active consumers.
      </p>
      }
      }
  </form>
</div>

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> Are you sure you want to remove this entry ?</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #billedUnitsValidationDialog let-cancel="cancel">
    <p>You have entered a shift that is longer than 13 hours and it needs to be verified. If your shift is correct,
      please click “Yes” to submit your shift. If this is not correct, click “Cancel” to modify your time and resubmit your
      shift.</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #pendedDialog let-cancel="cancel">
    <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
      [disabled]="true"></ppl-timesheet-staff-errorcode>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #deniedDialog let-cancel="cancel">
    <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData" [disabled]="true"></ppl-timesheet-staff-deniedreasons>
  </ng-template>
</div>